import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Role } from 'src/app/lem/models/common/role';
import { DepartmentsService } from '../../service/departments.service';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-search-role-department',
  templateUrl: './search-role-department.component.html',
  styleUrls: ['./search-role-department.component.css']
})
export class SearchRoleDepartmentComponent implements OnInit {

  @Input() labelTitle: string;
  @Input() labelButton: string;
  @Input() required: boolean;
  roles: PaginatedResponse<Role>;
  @Output() onSelect = new EventEmitter<Role>();
  lastSearch = null;
  personTypeSelect = null;
  openPanel = false;
  form : FormGroup;
  pagable : Pagable = new Pagable();
  roleSelected:Role;


  constructor(private formBuilder : FormBuilder,
    private departmentsService : DepartmentsService) {}

  ngOnInit() {
  }

  private initForm() {
    this.form = this.formBuilder.group({
      role: [this.roleSelected, Validators.required]
    });
  }



  cleanEmpty (obj) {
    for (let propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  resetForm(){
  }

  onChangePage(event: number) {
    this.pagable.page = event;
    this.findRoles();
  }

  updateCachedFilters(event: number) {

  }

  onSelectItemsPerPage(event: number) {
    this.pagable.size = event;
    this.findRoles();
  }

  onSelectRole(role: Role){
    this.onSelect.emit(role);
    this.openPanel = false;
    this.resetForm();
  }


  changeStatusPanel(){
    this.openPanel = !this.openPanel;
    if(this.openPanel && !this.roles){
      this.findRoles();
    }
  }


  private findRoles() {
    return this.departmentsService.getAllRoles(undefined, undefined, this.pagable).subscribe({
      next: (data) => {
        this.roles = data;
      },
      error: () => { }
    });
  }

  onRefresh(pagination: Pagination){
    this.pagable.page = pagination.getCurrentPage();
    this.pagable.size = pagination.getItemsPerPage();
    this.findRoles();
  }
}
